/**
 * Shared utilities for Season Overview widgets
 */

export const getMatchResult = (match) => {
  const our = match.our_score || 0;
  const opp = match.opponent_score || 0;
  const isCup = match.is_cup;

  if (isCup) {
    const ourPens = match.our_score_pens;
    const oppPens = match.opponent_score_pens;
    const ourET = match.our_score_et;
    const oppET = match.opponent_score_et;

    if (ourPens != null && oppPens != null) {
      return ourPens > oppPens ? 'W' : ourPens < oppPens ? 'L' : 'D';
    }
    if (ourET != null && oppET != null) {
      return ourET > oppET ? 'W' : ourET < oppET ? 'L' : 'D';
    }
  }
  return our > opp ? 'W' : our < opp ? 'L' : 'D';
};

export const getMatchScore = (match) => {
  const isCup = match.is_cup;
  const ourET = match.our_score_et;
  const oppET = match.opponent_score_et;

  if (isCup && ourET != null && oppET != null) {
    return `${ourET} - ${oppET}`;
  }
  return `${match.our_score} - ${match.opponent_score}`;
};

export const getMatchLabel = (match) => {
  const isCup = match.is_cup;
  const ourPens = match.our_score_pens;
  const oppPens = match.opponent_score_pens;
  const ourET = match.our_score_et;
  const oppET = match.opponent_score_et;

  if (isCup && ourPens != null && oppPens != null) {
    return `PEN (${ourPens}-${oppPens})`;
  }
  if (isCup && ourET != null && oppET != null) {
    return 'AET';
  }
  return 'FT';
};

export const formatSeasonDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString + 'T00:00:00');
  return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};
